import ListFilterFieldsGeneric from './ListFilterFieldsGeneric' // Template für vordefinierte Filter
let Filter = ListFilterFieldsGeneric('Mittelgeber') // Initialisieren des Templates für eine Entität

export default {
  label: 'Mittelgeber',
  route: 'mittelgeber',
  fields: [
    Filter.String('name'),
    Filter.Number('finSchluessel')
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/MittelgeberFilter.js